import { Modules } from '../../../util/modules'
import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../../auth'

// Invoices Integrations App
const XeroApp = () => import('@/pmd/pages/payments/payment-products/invoices-integrations/Xero.vue')
const WaveApp = () => import('@/pmd/pages/payments/payment-products/invoices-integrations/Wave.vue')

export const invoicesIntegrationsRoutes: RouteConfig[] = [
    {
        path: 'payments/v2/invoices-integrations/xero',
        name:'invoices-integrations-xero',
        component:  XeroApp,
        beforeEnter: requireAuthAndLocation,
        meta: {
            hideSideBar: true,
            hideTopBar: true,
            translations: [Modules.Payments],
        },
        children: []
    },
    {
        path: 'payments/v2/invoices-integrations/wave',
        name:'invoices-integrations-wave',
        component:  WaveApp,
        beforeEnter: requireAuthAndLocation,
        meta: {
            hideSideBar: true,
            hideTopBar: true,
            translations: [Modules.Payments],
        },
        children: []
    }
]
